/**
 * Save for Later — GoKwik shadow-DOM cart drawer bridge
 */
(function () {
  'use strict';

  if (window.__SflGokwikLoaded) return;
  window.__SflGokwikLoaded = true;

  var HOST_TAG = 'shadow-dom-container';
  var ITEM_SELECTOR = '.product-tile-wrapper';
  var TITLE_SELECTOR = '.sidecart-product-title, .product-title, [class*="product-title"], [class*="item-title"], [class*="sidecart-product-title"]';
  var ACTIONS_SELECTOR = '.item-price .quantity-handler-wrapper'; 
  var BTN_CLASS = 'sfl-save-for-later-btn';
  var PROCESSED_ATTR = 'data-sfl-processed';

  function log() {
    console.log.apply(console, ['[SFL]'].concat(Array.prototype.slice.call(arguments)));
  }

  function getShadowRoot() {
    var host = document.querySelector(HOST_TAG);
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  async function getCartItems() {
    try {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return [];
      var data = await res.json();
      return data.items || [];
    } catch (e) {
      console.error('[SFL] Failed to fetch /cart.js', e);
      return [];
    }
  }

  function normalizeTitle(str) {
    return (str || '').trim().toLowerCase();
  }

  async function matchCartItem(titleText) {
    var items = await getCartItems();
    var target = normalizeTitle(titleText);

    var match = items.find(function (it) {
      return normalizeTitle(it.product_title) === target;
    });

    if (!match) {
      match = items.find(function (it) {
        var t = normalizeTitle(it.product_title);
        return t && (target.indexOf(t) !== -1 || t.indexOf(target) !== -1);
      });
    }

    return match || null;
  }

  async function removeFromCart(cartItem) {
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: cartItem.key, quantity: 0 })
      });
      return res.ok;
    } catch (e) {
      console.error('[SFL] Failed to remove item from cart', e);
      return false;
    }
  }

  function setButtonState(btn, state) {
    if (state === 'loading') {
      btn.disabled = true;
      btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
      btn.textContent = 'Saving...';
    } else if (state === 'done') {
      btn.textContent = 'Saved!';
    } else if (state === 'error') {
      btn.disabled = false;
      btn.textContent = 'Try again';
    } else {
      btn.disabled = false;
      btn.textContent = btn.dataset.originalText || 'Save for later';
    }
  }

  function maybeRefreshWishlistPage() {
    // Disabled window reload to allow dynamic, on-the-spot wishlist grid updates via Swym SDK
    log('On wishlist page — dynamic updates triggered.');
  }

  function removeGokwikItem(itemEl) {
    // 1. Try to find trash icon, delete button, or remove text inside the item tile
    var deleteBtn = itemEl.querySelector(
      'button[class*="delete"], button[class*="remove"], [class*="delete-icon"], [class*="remove-icon"], svg[class*="delete"], svg[class*="remove"], [aria-label*="Remove"], [aria-label*="Delete"], .delete-btn, .remove-btn'
    );
    
    if (deleteBtn) {
      log('Found GoKwik native delete button, clicking it:', deleteBtn);
      deleteBtn.click();
      return true;
    }

    // 2. Try to find the minus button inside the quantity handler to decrement to 0
    var actionsRow = itemEl.querySelector(ACTIONS_SELECTOR);
    if (actionsRow) {
      var minusBtn = actionsRow.querySelector('button, span, div, svg');
      if (minusBtn && minusBtn.tagName !== 'INPUT') {
        var qtyInput = actionsRow.querySelector('input');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (isNaN(qty) || qty <= 0) qty = 1;
        
        log('Found GoKwik native minus button, clicking it ' + qty + ' times:', minusBtn);
        for (var i = 0; i < qty; i++) {
          (function(index) {
            setTimeout(function() {
              minusBtn.click();
            }, index * 100);
          })(i);
        }
        return true;
      }
    }

    return false;
  }

  // =========================================================================
  // FIXED (2026-08-07): Add-to-cart button on dynamically injected wishlist
  // cards was dead until a page refresh. The native Wishlist Plus page
  // script only binds click handlers to .wl-add-to-cart-btn elements that
  // exist at page load (via querySelectorAll) — it has no MutationObserver
  // to notice cards we prepend via addCardToWishlistGrid(). So the button
  // rendered fine but did nothing on click. This binds a self-contained
  // click handler directly to the button the moment we create it, calling
  // Shopify's /cart/add.js AJAX endpoint ourselves instead of depending on
  // the native script to notice the new DOM node.
  // =========================================================================
  function bindAddToCartHandler(btn, cartItem) {
    if (!btn || btn.hasAttribute('data-sfl-atc-bound')) return;
    btn.setAttribute('data-sfl-atc-bound', 'true');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: cartItem.variant_id,
          quantity: 1
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (errData) {
              throw new Error((errData && errData.description) || 'Failed to add to cart');
            });
          }
          return res.json();
        })
        .then(function () {
          log('Dynamically-added card: add to cart success for variant', cartItem.variant_id);
          btn.textContent = 'Added!';
          // Same events already used elsewhere so the header cart badge,
          // cart drawer, etc. all pick this up without a page refresh.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          console.error('[SFL] Add to cart failed for dynamically added card:', err);
          btn.textContent = 'Try again';
          btn.disabled = false;
        });
    });
  }

  function addCardToWishlistGrid(cartItem) {
    console.log('[SFL] Checking wishlist grid pre-rendering for variant ID:', cartItem.variant_id);
    var grid = document.getElementById('wl-product-grid');
    if (!grid) {
        console.log('[SFL] Not on wishlist page or grid container `#wl-product-grid` not found. Skipping dynamic card prepend.');
        return;
    }

    // Check if the card already exists in the grid
    if (grid.querySelector('[data-variant-id="' + cartItem.variant_id + '"]')) {
        console.log('[SFL] Product card already exists in the grid. Skipping prepend.');
        return;
    }

    console.log('[SFL] Pre-rendering product card in wishlist grid on the spot...');

    var formattedPrice = 'Rs. ' + ((cartItem.price / 100).toFixed(2));
    if (typeof cartItem.price === 'string') {
        formattedPrice = cartItem.price;
    } else if (typeof cartItem.original_line_price === 'number') {
        formattedPrice = 'Rs. ' + (cartItem.original_line_price / 100).toFixed(2);
    }

    var card = document.createElement('div');
    card.className = 'wl-product-card';
    card.setAttribute('data-product-id', cartItem.product_id);
    card.setAttribute('data-variant-id', cartItem.variant_id);
    card.setAttribute('bis_skin_checked', '1');

    var productUrl = '/products/' + cartItem.handle;

    card.innerHTML = 
        '<div class="wl-product-image-wrapper" bis_skin_checked="1">' +
            '<input type="checkbox" class="wl-card-checkbox" aria-label="Select item" disabled="" style="opacity: 0.4; cursor: not-allowed;">' +
            '<button class="wl-card-delete-btn" aria-label="Delete item">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                    '<polyline points="3 6 5 6 21 6"></polyline>' +
                    '<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>' +
                '</svg>' +
            '</button>' +
            '<a href="' + productUrl + '">' +
                '<img class="wl-product-image" src="' + cartItem.image + '" alt="' + cartItem.product_title + '" loading="lazy">' +
            '</a>' +
        '</div>' +
        '<div class="wl-product-info" bis_skin_checked="1">' +
            '<h3 class="wl-product-title">' +
                '<a href="' + productUrl + '">' + cartItem.product_title + '</a>' +
            '</h3>' +
            '<p class="wl-variant-title">' + (cartItem.variant_title ? (cartItem.product_title + ' - ' + cartItem.variant_title) : cartItem.product_title) + '</p>' +
            '<div class="wl-product-price" bis_skin_checked="1">' + formattedPrice + '</div>' +
            '<button class="wl-add-to-cart-btn" data-variant-id="' + cartItem.variant_id + '" data-product-id="' + cartItem.product_id + '">Add to cart</button>' +
        '</div>';

    // Prepend to the top of the grid
    if (grid.firstChild) {
        grid.insertBefore(card, grid.firstChild);
    } else {
        grid.appendChild(card);
    }
    console.log('[SFL] Prepend success. Pre-rendered item prepended to grid.');

    // FIXED: bind our own working click handler to the new Add to cart
    // button, since the native page script never sees this dynamically
    // added node and would otherwise leave it dead until a refresh.
    var addToCartBtn = card.querySelector('.wl-add-to-cart-btn');
    bindAddToCartHandler(addToCartBtn, cartItem);

    // Bind delete button listener for the newly added card
    var delBtn = card.querySelector('.wl-card-delete-btn');
    if (delBtn) {
        delBtn.addEventListener('click', function(e) {
            e.preventDefault();
            console.log('[SFL] Custom card delete button clicked. Calling swat.removeFromWishList for variant:', cartItem.variant_id);
            if (window._swat && typeof window._swat.removeFromWishList === 'function') {
                window._swat.removeFromWishList({
                    epi: cartItem.variant_id,
                    empi: cartItem.product_id,
                    du: window.location.origin + productUrl
                }, function() {
                    console.log('[SFL] swat.removeFromWishList callback fired. Removing card from DOM.');
                    card.remove();
                    if (window.__wishlistCache) {
                        var idx = window.__wishlistCache.indexOf(String(cartItem.variant_id));
                        if (idx !== -1) {
                            window.__wishlistCache.splice(idx, 1);
                        }
                    }
                    if (typeof window.updateAllHeaderWishlistBadges === 'function') {
                        window.updateAllHeaderWishlistBadges();
                    }
                    try {
                        document.dispatchEvent(new CustomEvent('wishlist:updated', {
                            bubbles: true,
                            detail: { cache: window.__wishlistCache }
                        }));
                    } catch(e) {}
                });
            } else {
                console.warn('[SFL] Swym SDK not available to delete. Removing from DOM only.');
                card.remove();
            }
        });
    }

    // Hide empty state if it is currently displayed
    var emptyState = document.getElementById('wl-empty-state');
    if (emptyState) {
        emptyState.style.display = 'none';
    }
  }

  async function handleSaveForLaterClick(evt) {
    var btn = evt.currentTarget;
    if (btn.disabled) return;

    var itemEl = btn.closest(ITEM_SELECTOR);
    if (!itemEl) return;

    var titleEl = itemEl.querySelector(TITLE_SELECTOR);
    var titleText = titleEl ? titleEl.textContent : '';

    console.log('[SFL] "Save for Later" clicked for item:', titleText);
    setButtonState(btn, 'loading');

    var cartItem = await matchCartItem(titleText);
    if (!cartItem) {
      console.error('[SFL] Could not match cart line item for title:', titleText);
      setButtonState(btn, 'error');
      return;
    }

    console.log('[SFL] Matched cart line item:', cartItem);

    var result;
    try {
      console.log('[SFL] Calling wishlistPlus.addToWishlist...');
      result = await window.wishlistPlus.addToWishlist({
        productId: cartItem.product_id,
        variantId: cartItem.variant_id,
        productHandle: cartItem.handle,
        showModal: false 
      });
      console.log('[SFL] addToWishlist API result:', result);
    } catch (e) {
      console.error('[SFL] addToWishlist threw', e);
      setButtonState(btn, 'error');
      return;
    }

    var okStatuses = ['added', 'already_added'];
    if (result && result.success && okStatuses.indexOf(result.status) !== -1) {
      // Pre-render the card on the wishlist grid dynamically
      try {
        addCardToWishlistGrid(cartItem);
      } catch (gridErr) {
        console.error('[SFL] Pre-rendering wishlist card failed:', gridErr);
      }

      // Try to remove using GoKwik's native button first for on-the-spot UI updates
      var removed = false;
      try {
        console.log('[SFL] Attempting to remove item from cart drawer using GoKwik shadow-DOM controls...');
        removed = removeGokwikItem(itemEl);
        console.log('[SFL] GoKwik shadow-DOM removal triggered successfully:', removed);
      } catch (gkErr) {
        console.error('[SFL] GoKwik native remove failed:', gkErr);
      }

      // Fallback: manually remove via API and dispatch theme events to force update
      if (!removed) {
        console.warn('[SFL] GoKwik shadow-DOM controls not found. Falling back to manual API call...');
        var manualRemoved = await removeFromCart(cartItem);
        if (manualRemoved) {
          console.log('[SFL] Manual cart removal API success. Dispatching events to refresh theme cart...');
          setButtonState(btn, 'done');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          maybeRefreshWishlistPage();
        } else {
          console.error('[SFL] Fallback manual cart removal failed.');
          setButtonState(btn, 'error');
        }
      } else {
        setButtonState(btn, 'done');
        maybeRefreshWishlistPage();
      }
    } else if (result && result.status === 'login_required') {
      console.warn('[SFL] Login required to save item.');
      setButtonState(btn, 'idle');
    } else {
      console.error('[SFL] Failed to save item to wishlist.');
      setButtonState(btn, 'error');
    }
  }

  function injectButton(itemEl) {
    if (itemEl.hasAttribute(PROCESSED_ATTR)) return;
    itemEl.setAttribute(PROCESSED_ATTR, '1');

    var actionsRow = itemEl.querySelector(ACTIONS_SELECTOR);
    if (!actionsRow) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN_CLASS;
    btn.textContent = 'Save for later';
    btn.style.cssText =
      'margin-top:8px;padding:4px 10px;font-size:12px;border:1px solid #999;' +
      'background:#fff;color:#333;border-radius:6px;cursor:pointer;';
    btn.addEventListener('click', handleSaveForLaterClick);

    actionsRow.insertAdjacentElement('afterend', btn);
  }

  var HEART_SVG_INLINE = '<svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="display:inline-block;vertical-align:text-bottom;margin-right:4px;fill:currentColor;"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function injectWishlistBadges(root) {
    var pos = (window.__sylviWishlistBadge || {}).position || 'image';
    // Remap legacy values (saved before options were renamed)
    if (pos === 'title' || pos === 'both') pos = 'title_before';
    if (pos === 'image-only') pos = 'image';
    if (pos === 'none') return;

    var tiles = root.querySelectorAll(ITEM_SELECTOR);
    log('[Badge] Scanning ' + tiles.length + ' tiles, pos=' + pos);

    tiles.forEach(function(tile) {
      var propEl = tile.querySelector('[data-item-property="_is_wishlist"]');
      log('[Badge] tile propEl found:', !!propEl);
      if (!propEl) return;

      // Dynamically hide the parent property list wrapper to prevent blank space/margins
      var parentList = propEl.closest('.item-properties-list');
      if (parentList) {
        parentList.style.setProperty('display', 'none', 'important');
        parentList.style.setProperty('margin-top', '0', 'important');
        parentList.style.setProperty('margin-bottom', '0', 'important');
        parentList.style.setProperty('height', '0', 'important');
      }

      var propVal = propEl.textContent || '';
      if (!propVal.toLowerCase().includes('true')) return;

      // --- Option 1: On image top-left only ---
      if (pos === 'image') {
        if (tile.querySelector('.sylvi-wl-image-badge')) return; // already injected

        var badge = document.createElement('div');
        badge.className = 'sylvi-wl-image-badge';
        badge.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

        // Anchor to tile — always works. Badge CSS uses position:absolute top-left.
        tile.style.position = 'relative';
        tile.insertBefore(badge, tile.firstChild);
        log('[Badge] Image badge injected into tile');
      }

      // --- Option 2: Before item title only ---
      if (pos === 'title_before') {
        var titleEl = tile.querySelector(TITLE_SELECTOR);
        if (titleEl && !titleEl.querySelector('.sylvi-wl-title-heart')) {
          var heartSpan = document.createElement('span');
          heartSpan.className = 'sylvi-wl-title-heart';
          heartSpan.innerHTML = HEART_SVG_INLINE;
          titleEl.insertBefore(heartSpan, titleEl.firstChild);
          log('[Badge] Title-before heart injected');
        }
      }

      // --- Option 3: After item title only (placed on next line under title) ---
      if (pos === 'title_after') {
        var titleEl = tile.querySelector(TITLE_SELECTOR);
        // Find if heart is already injected in the title's parent
        if (titleEl && !titleEl.parentElement.querySelector('.sylvi-wl-title-heart')) {
          var heartSpan = document.createElement('span');
          heartSpan.className = 'sylvi-wl-title-heart';
          heartSpan.innerHTML = HEART_SVG_INLINE;
          titleEl.insertAdjacentElement('afterend', heartSpan);
          log('[Badge] Title-after heart injected');
        }
      }
    });
  }



  function scanAndInject(root) {
    var items = root.querySelectorAll(ITEM_SELECTOR);
    items.forEach(injectButton);
    injectWishlistBadges(root);
  }

  function startObserving() {
    var root = getShadowRoot();
    if (!root) {
      setTimeout(startObserving, 300);
      return;
    }

    // Read position setting BEFORE injecting CSS
    var pos = (window.__sylviWishlistBadge || {}).position || 'image';
    // Remap legacy values (saved before options were renamed)
    if (pos === 'title' || pos === 'both') pos = 'title_before';
    if (pos === 'image-only') pos = 'image';
    var showTitleHeart = pos === 'title_before' || pos === 'title_after';

    // Inject CSS for the wishlist heart directly into the shadow DOM
    if (!root.querySelector('#sylvi-gokwik-wishlist-style')) {
      var style = document.createElement('style');
      style.id = 'sylvi-gokwik-wishlist-style';

      // ::before heart rule — only injected when position includes title
      var beforeTitleCSS = showTitleHeart ? `
        [data-item-property="_is_wishlist"]::before {
            content: "";
            display: inline-block;
            width: 14px;
            height: 14px;
            background-color: currentColor;
            -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/%3E%3C/svg%3E");
            mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/%3E%3C/svg%3E");
            -webkit-mask-size: contain;
            mask-size: contain;
            -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
            margin-right: 4px;
            vertical-align: text-bottom;
        }
      ` : `
        [data-item-property="_is_wishlist"]::before {
            display: none !important;
            content: none !important;
        }
      `;

      style.textContent = `
        /* Fully hide the GoKwik wishlist property row (prevents native ♥ text below title) */
        [data-item-property="_is_wishlist"] {
            display: none !important;
        }
        /* Hide the container wrapper list to prevent empty space/margins */
        .item-properties-list:has([data-item-property="_is_wishlist"]),
        .item.svelte-10zz03f .item-properties-list.svelte-10zz03f:has([data-item-property="_is_wishlist"]) {
            display: none !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
            height: 0 !important;
        }
        /* Fallback selector for browsers/scenarios if :has is not supported */
        .item-properties-list,
        .item.svelte-10zz03f .item-properties-list.svelte-10zz03f {
            margin-top: 0 !important;
            margin-bottom: 0 !important;
        }
        /* Suppress ::before heart — title option removed */
        [data-item-property="_is_wishlist"]::before {
            display: none !important;
            content: none !important;
        }
        /* Image badge styles */
        .sylvi-wl-image-badge {
            position: absolute;
            top: 6px;
            left: 6px;
            width: 24px;
            height: 24px;
            background: rgba(255,255,255,0.92);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 6px rgba(0,0,0,0.15);
            z-index: 10;
        }
        .sylvi-wl-image-badge svg {
            fill: #121214;
            display: block;
        }
        /* Title heart (placed on next line under title) */
        .sylvi-wl-title-heart {
            display: block !important;
            margin-top: 4px;
            margin-bottom: 4px;
            margin-left: 0;
            margin-right: 0;
            line-height: 1;
        }
        .sylvi-wl-title-heart svg {
            fill: #121214;
            display: inline-block;
            vertical-align: middle;
        }
      `;
      root.appendChild(style);
    }

    scanAndInject(root);

    var mo = new MutationObserver(function () {
      scanAndInject(root);
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();